import { TimePin } from "../../../library-js/animation/TimePin";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnChange, OnClick } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { LanguageCode } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { LangBlock } from "../lang-block/LangBlock";
import { OverlayHint, OverlayHintOptions } from "../overlay/OverlayHint";
import { Rokojori } from "../Rokojori";
import { SetCartItems } from "./SetCartItems";

export class AddToCartLink
{
  static readonly addingText = { en: "Adding item...", de:"Füge Artikel hinzu..." };
  static readonly removingText = { en: "Removing item...", de:"Entferne Artikel..." };
  static readonly regex = /\#add\-to\-cart$/;
  
  static readonly toCart = new ElementAttribute( "to-cart" );
  static readonly toWishlist = new ElementAttribute( "to-wishlist" );

  static is( e:Element ):boolean
  {
    if ( ! ElementType.anchor.is( e ) )
    {
      return;
    }

    return ElementAttribute.href.is( e, AddToCartLink.regex );
  }

  static applyOnDocument()
  {
    AddToCartLink.toCart.forEachInDoc( e => AddToCartLink.applyOnElement( e, false ) );
    AddToCartLink.toWishlist.forEachInDoc( e => AddToCartLink.applyOnElement( e, true ) );
  }

  static applyOnElement( element:Element, onWishlist:boolean )
  {
    let id = onWishlist ? AddToCartLink.toWishlist.from( element ) : AddToCartLink.toCart.from( element );

    this.applyElement( element, id, onWishlist, false );
  }

  static applyElement( element:Element, id:string, wishlist:boolean, checkHref:boolean = true )
  {
    if ( checkHref && ! AddToCartLink.is( element ) )
    {
      return;
    }

    if ( checkHref )
    {
      ElementAttribute.href.removeFrom( element );
    }
    

    let cart = Rokojori.$.assetManagerServer.assetsCart;

    OnClick.add( element as HTMLElement, 
      async ()=>
      {     
        console.log( "adding item", id );

        Rokojori.$.showLoaderScreen( AddToCartLink.addingText );

        let pin = TimePin.create();


        let result = await cart.add( id, wishlist );

        SetCartItems.applyOnDocument();

        await pin.forMS( 500 ); 

        pin.now();

        Rokojori.$.hideLoaderScreen();

        if ( cart.hideQuestion )
        {
          return;
        }

        console.log( "result", result );

        await pin.forMS( 300 ); 

        this.askToCartQuestion();

      } 
    )
  }

  static async askToCartQuestion()
  {
    let options = new OverlayHintOptions();
    options.isCancable = true;
    options.isClosable = true;

    let title:MultiString = 
    {
      en: `Very Excellent Choice!`,
      de: `Eine ausgezeichnete Wahl!`
    };

  

    let content = 
    {
      en: HTMLEditor.stringToElement(
      `<div>
      <br>
      <b>Do you want to see your cart?</b>
      <br><br><br><br>  
      <input type="checkbox"></input> Don't ask again... I know it's on the top right.
      <br><br>
      </div>` ),

      de:HTMLEditor.stringToElement(
      `<div>
      <br><br>  
      <b>Möchtest du deinen Warenkorb anschauen?</b>
      <br><br> <br><br>  
      <input type="checkbox"></input> Nicht nochmal fragen... Ich weiß, dass er oben rechts ist.
      <br><br>
      </div>`)
    };

    let confirmContent:MultiString = 
    {
      en: `To Shopping Cart`,
      de: `Zum Warenkorb`
    };
    
    let cancelContent:MultiString = 
    {
      en: `Continue Shopping`,
      de: `Weiter einkauen`
    };
    
    let language = Rokojori.$.pageHandler.currentLanguage as LanguageCode;

    let customizer = ( e:Element )=>
    {
      let confirm = OverlayHint.confirm.queryAll( e );
      let cancel  = OverlayHint.cancel.queryAll( e );

      let checkboxInput = ElementType.input.query( e );

      OnChange.add( 
        checkboxInput, async ()=>
        {
          console.log( "CHANGING", checkboxInput.value );
          let cart = Rokojori.$.assetManagerServer.assetsCart;

          cart.hideQuestion = checkboxInput.checked;

          await cart.update();
          //Rokojori.$.cart.setHideToCartQuestion( checkboxInput.value === "on" );
        }

      );
      confirm.forEach(
        ( b )=>
        {
          let parent = LangBlock.type.getParent( b );
          HTMLEditor.setText( b, confirmContent[ LangBlock.getLanguage( parent ) ] );
        }
      )

      cancel.forEach(
        ( b )=>
        {
          let parent = LangBlock.type.getParent( b );
          HTMLEditor.setText( b, cancelContent[ LangBlock.getLanguage( parent ) ] );
        }
      )
    };

    let result = await OverlayHint.hint( title[ language ], ( content as any )[ language ] , options, customizer );   
    
    if ( ! result.confirmed )
    {
      return;
    }

    let cartLink:MultiString = 
    {
      en: "::/en/cart",
      de: "::/de/warenkorb"
    }

    Rokojori.$.pageHandler.setPage( cartLink[ language ] );
  }
}